// extracted by mini-css-extract-plugin
export default {"input":"Input_input__sReBl","hideNumberArrows":"Input_hideNumberArrows__K3cMW","select":"Input_select__2hD2J"};